export const pixelTesterInitialValues = {
    pixelTesterUrl: '',
    pixelTesterWebsiteUrl: '',
    pixelTesterEvents: [],
};
